import {
  Button,
  Card,
  CardContent,
  CardHeader,
  createMuiTheme,
  Grid,
  List,
  ListItem,
  TextField,
  Typography,
} from "@material-ui/core";
import { ThemeProvider } from "@material-ui/core/styles";
import { GetApp, Search } from "@material-ui/icons";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { UserDataContext } from "../Contexts/UserDataContext";
import { downloadData } from "../GlobalFunctions";
import CustomTable from "./CustomTable";
import DatePicker from "./DatePicker";
import DateTextField from "./DateTextField";

const InvoiceAuditPage = ({ ...otherProps }) => {
  const [searchTerms, setSearchTerms] = useState(() => {
    const today = new Date();
    const lastMonth = new Date();
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    return {
      invoiceId: "",
      truckId: "",
      vendorTradingName: "",
      vendorNumber: "",
      datesFrom: lastMonth,
      datesTo: today,
    };
  });

  const [data, setData] = useState([]);

  // const data = [
  //   {
  //     invoiceNo: "20220200903",
  //     invoiceDate: new Date("2020-08-16"),
  //     vendorName: "Probotics",
  //     vendorId: 3,
  //     truckId: 202,
  //     submittedBy: "Hana Charlton",
  //     dateSubmitted: new Date("2020-08-20"),
  //     preApprovedBy: "Carolina Love",
  //     datePreApproved: new Date("2020-08-21"),
  //     approvedBy: "Anum Rav",
  //     dateApproved: new Date("2020-08-22"),
  //     unibis: "2020-09-18.csv",
  //     supportingDocs: ["asdasd.csv", "Sdfsdf.png"],
  //   },
  // ];

  const { userData } = useContext(UserDataContext);

  const handleDownloadFile = (route, fileName) => {
    axios({
      method: "GET",
      url: `/files/${route}/${fileName}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userData.token}`,
      },
      data: searchTerms,
    })
      .then((res) => downloadData(res.data))
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    // get invoice array
    axios({
      method: "POST",
      url: `/audit/GetInvoiceAuditData/`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userData.token}`,
      },
      data: searchTerms,
    })
      .then((res) => {
        console.log(
          res.data.sort(
            (a, b) =>
              new Date(a.invoiceDate).valueOf() -
              new Date(b.invoiceDate).valueOf()
          )
        );
        setData(res.data);
      })
      .catch((error) => console.log(error));
  }, [userData.token, searchTerms]);

  const searchFieldList = [
    {
      label: "Invoice Number",
      field: "invoiceId",
    },
    {
      label: "Truck Id",
      field: "truckId",
    },
    {
      label: "Vendor Name",
      field: "vendorTradingName",
    },
    {
      label: "Vendor Id",
      field: "vendorNumber",
    },
    {
      label: "Invoice Dates From",
      field: "datesFrom",
      variant: "date",
      disableFuture: true,
    },
    {
      label: "Invoice Dates To",
      field: "datesTo",
      variant: "date",
      disableFuture: false,
    },
  ];

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Card>
          <CardHeader title="Invoice Audit Page" />
          <CardContent>
            <Grid container spacing={3} alignItems="flex-end">
              {searchFieldList.map(({ label, field, variant, ...other }) => (
                <Grid item key={label} xs={12} sm={3}>
                  {variant === "date" ? (
                    // <DatePicker
                    //   {...other}
                    //   style={{ margin: 0 }}
                    //   fullWidth
                    //   inputVariant="outlined"
                    //   label={label}
                    //   value={searchTerms[field]}
                    //   onChange={(value) =>
                    //     setSearchTerms({ ...searchTerms, [field]: value })
                    //   }
                    //   />
                    <DateTextField
                      // {...other}
                      fullWidth
                      variant="outlined"
                      value={searchTerms[field]}
                      onChange={(value) =>
                        setSearchTerms({ ...searchTerms, [field]: value })
                      }
                      label={label}
                    />
                  ) : (
                    <TextField
                      {...other}
                      fullWidth
                      variant="outlined"
                      value={searchTerms[field]}
                      onChange={(e) =>
                        setSearchTerms({
                          ...searchTerms,
                          [field]: e.target.value,
                        })
                      }
                      label={label}
                    />
                  )}
                </Grid>
              ))}
              <Grid item sm={3} />
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <ThemeProvider theme={lowerCaseButtonTheme}>
          <CustomTable
            options={{ search: false }}
            title="Search Results"
            defaultAlign="center"
            detailPanel={(row) => (
              <List>
                {row.invoicePDFFileName && (
                  <ListItem>
                    <DownloadButton
                      label="Invoice PDF"
                      onClick={() =>
                        handleDownloadFile("GetInvoicePDF", row.id)
                      }
                    />
                  </ListItem>
                )}
                {row.transactionsFileName && (
                  <ListItem>
                    <DownloadButton
                      label="Transactions CSV"
                      onClick={() =>
                        handleDownloadFile(
                          "DownloadInvoiceDPC",
                          row.transactionsFileName
                        )
                      }
                    />
                  </ListItem>
                )}
                {row.unibisFileName && (
                  <ListItem>
                    <DownloadButton
                      label={"Unibis File: " + row.unibisFileName}
                      onClick={() =>
                        handleDownloadFile("DownloadUnibis", row.unibisFileName)
                      }
                    />
                  </ListItem>
                )}
                {row.supportingDocs && row.supportingDocs.length !== 0 && (
                  <ListItem>
                    <Typography>Supporting Documents:</Typography>
                  </ListItem>
                )}
                {row.supportingDocs.map((x) => (
                  <ListItem key={x.fileName}>
                    <DownloadButton
                      label={x.fileName}
                      onClick={() =>
                        handleDownloadFile("DownloadSupportFile", x.fileName)
                      }
                    />
                  </ListItem>
                ))}
              </List>
            )}
            columns={[
              {
                title: "Invoice Number",
                field: "id",
              },
              {
                title: "Invoice Date",
                field: "invoiceDate",
                render: (row) =>
                  new Date(row.invoiceDate).toLocaleDateString("en-NZ"),
              },
              {
                title: "Vendor Name",
                field: "vendorTradingName",
              },
              {
                title: "Vendor Id",
                field: "vendorNumber",
              },
              {
                title: "Truck Id",
                field: "truckId",
              },
              {
                title: "Submitted By",
                field: "submittedUserName",
              },
              {
                title: "Date Submitted",
                field: "submittedDateTime",
                render: (row) =>
                  new Date(row.submittedDateTime).toLocaleDateString("en-NZ"),
              },
              {
                title: "Pre-Approved By",
                field: "preApprovedUserName",
              },
              {
                title: "Date Pre-Approved",
                field: "preApprovedDateTime",
                render: (row) =>
                  new Date(row.preApprovedDateTime).toLocaleDateString("en-NZ"),
              },
              {
                title: "Approved By",
                field: "approvedUserName",
              },
              {
                title: "Date Approved",
                field: "approvedDateTime",
                render: (row) =>
                  new Date(row.approvedDateTime).toLocaleDateString("en-NZ"),
              },
            ]}
            data={data}
          />
        </ThemeProvider>
      </Grid>
    </Grid>
  );
};

const lowerCaseButtonTheme = createMuiTheme({
  typography: {
    button: {
      textTransform: "none",
    },
  },
});

const DownloadButton = ({ label, onClick }) => (
  <Button onClick={onClick}>
    <GetApp />
    <Typography>{label}</Typography>
  </Button>
);

export default InvoiceAuditPage;
